import 'react-app-polyfill/ie11';
import 'core-js/features/array/find';
import 'core-js/features/array/includes';
import 'core-js/features/number/is-nan';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import App from './App';
import './scss/base.scss';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import combineReducers from './reducers';

const root = ReactDOM.createRoot(document.getElementById('root'));
const store = createStore(combineReducers);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorker.unregister();